import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const MCDraggableTabs = ({ activeView, viewsOnTabs, setViewsOnTabs, handleViewSelection, hideViewFromTabs }) => {
    const [tabs, setTabs] = useState(viewsOnTabs);

    useEffect(() => {
        setTabs(viewsOnTabs);
    }, [activeView, viewsOnTabs]);

    const saveTabOrder = async (newTabs) => {
        let updates = []
        let newTabsOrder = newTabs.map((t, i) => {
            t.tab_order = i + 1
            updates.push({ id: t.id, tab_order: t.tab_order })
            return t
        })
        setTabs(newTabsOrder);

        try {
            const res = await fetch("/api/v1/preferences/update_views", {
                method: "PATCH",
                headers: {
                    'X-CSRF-Token': window.token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    updates: updates
                }),
            });

            if (!res.ok) {
                throw new Error('Network response was not ok.');
            } else {
                setViewsOnTabs(newTabsOrder)
            }
        } catch (error) {
            console.error("Error saving tab order:", error);
        }
    };

    const onDragEnd = (result) => {
        if (!result.destination) return;
        const newTabs = Array.from(tabs);
        const [movedTab] = newTabs.splice(result.source.index, 1);
        newTabs.splice(result.destination.index, 0, movedTab);
        saveTabOrder(newTabs);
    };

    return (
        <ul id='nav-tabs-manage-clients' className='report-tab-list' role='tablist' >
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="tabs" direction="horizontal">
                    {(provided) => (
                        <ul id="nav-tabs-manage-clients" className="report-tab-list" role="tablist" ref={provided.innerRef} {...provided.droppableProps}>
                            {tabs.map((tab, index) => (
                                // Draggable requires a [string] draggableId.
                                <Draggable key={tab.id} draggableId={tab.id.toString()} index={index}>
                                    {(provided) => (
                                        <li
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className={tab.id === activeView.id ? "mc-view-tab-item active" : "mc-view-tab-item"}
                                            role="presentation"
                                            onClick={() => handleViewSelection(tab)}
                                        >
                                            <span>{tab.name}</span>
                                            <button
                                                type="button"
                                                className="view-close-btn"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    hideViewFromTabs(tab.id);
                                                }}
                                            >
                                                <i className="fa fa-times"></i>
                                            </button>
                                        </li>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>
        </ul>
    )
}

export default MCDraggableTabs;